import React, { useState } from "react";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

const Navigation = (props) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <div>
      <Navbar color="dark" dark expand="md">
        <NavbarBrand href="/" style={{ marginRight: "50px" }}>
          ALLNEWS
        </NavbarBrand>
        <NavbarToggler onClick={toggle} />
        <Collapse isOpen={isOpen} navbar>
          <Nav className="mr-auto" navbar>
            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle nav caret>
                Network
              </DropdownToggle>
              <DropdownMenu right>
                <DropdownItem href="/abc-news">ABC News</DropdownItem>
                <DropdownItem href="/cbs-news">CBS News</DropdownItem>
                <DropdownItem href="/cnn">CNN</DropdownItem>
                <DropdownItem href="/fox-news">Fox</DropdownItem>
                <DropdownItem href="/msnbc">MSNBC</DropdownItem>
                <DropdownItem href="/nbc-news">NBC News</DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle nav caret>
                Paper
              </DropdownToggle>
              <DropdownMenu right>
                <DropdownItem href="/usa-today">USA Today</DropdownItem>
                <DropdownItem href="/washington-post">
                  Washington Post
                </DropdownItem>
                <DropdownItem href="/the-wall-street-journal">
                  Wall St Journal
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle nav caret>
                Magazine
              </DropdownToggle>
              <DropdownMenu right>
                <DropdownItem href="/entertainment-weekly">
                  Entertainment Weekly
                </DropdownItem>
                <DropdownItem href="/new-york-magazine">
                  New York Magazine
                </DropdownItem>
                <DropdownItem href="/time">Time</DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle nav caret>
                Politics
              </DropdownToggle>
              <DropdownMenu right>
                <DropdownItem href="/the-hill">The Hill</DropdownItem>
                <DropdownItem href="/politico">Politico</DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle nav caret>
                Finance
              </DropdownToggle>
              <DropdownMenu right>
                <DropdownItem href="/bloomberg">Bloomberg</DropdownItem>
                <DropdownItem href="/business-insider">
                  Business Insider
                </DropdownItem>
                <DropdownItem href="/financial-post">
                  Financial Post
                </DropdownItem>
                <DropdownItem href="/fortune">Fortune</DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle nav caret>
                Tech
              </DropdownToggle>
              <DropdownMenu right>
                <DropdownItem href="/engadget">Engadget</DropdownItem>
                <DropdownItem href="/google-news">Google News</DropdownItem>
                <DropdownItem href="/hacker-news">Hacker News</DropdownItem>
                <DropdownItem href="/ign">IGN</DropdownItem>
                <DropdownItem href="/polygon">Polygon</DropdownItem>
                <DropdownItem href="/recode">Recode</DropdownItem>
                <DropdownItem href="/reddit-r-all">Reddit</DropdownItem>
                <DropdownItem href="/techcrunch">TechCrunch</DropdownItem>
                <DropdownItem href="/techradar">TechRadar</DropdownItem>
                <DropdownItem href="/the-next-web">The Next Web</DropdownItem>
                <DropdownItem href="/the-verge">Verge</DropdownItem>
                <DropdownItem href="/wired">Wired</DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle nav caret>
                Conservative
              </DropdownToggle>
              <DropdownMenu right>
                <DropdownItem href="/breitbart-news">Breitbart</DropdownItem>
                <DropdownItem href="/fox-news">Fox News</DropdownItem>
                <DropdownItem href="/national-review">
                  National Review
                </DropdownItem>
                <DropdownItem href="/the-american-conservative">
                  American Conservative
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle nav caret>
                Sports
              </DropdownToggle>
              <DropdownMenu right>
                <DropdownItem href="/espn">ESPN</DropdownItem>
                <DropdownItem href="/fox-sports">Fox Sports</DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle nav caret>
                New Media
              </DropdownToggle>
              <DropdownMenu right>
                <DropdownItem href="/axios">Axios</DropdownItem>
                <DropdownItem href="/buzzfeed">Buzzfeed</DropdownItem>
                <DropdownItem href="/mashable">Mashable</DropdownItem>
                <DropdownItem href="/mtv-news">MTV News</DropdownItem>
                <DropdownItem href="/vice">Vice</DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </Nav>
        </Collapse>
      </Navbar>
    </div>
  );
};

export default Navigation;
